"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReceiptIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** ReceiptIcon */
var ReceiptIcon = function ReceiptIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Pending" : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return /*#__PURE__*/_react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 18 18"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Title, null, title), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    d: "M14 2.5H4V16.5H14V2.5ZM15 2V17C15 17.1326 14.9473 17.2598 14.8536 17.3536C14.7598 17.4473 14.6326 17.5 14.5 17.5H3.5C3.36739 17.5 3.24021 17.4473 3.14645 17.3536C3.05268 17.2598 3 17.1326 3 17V2C3 1.86739 3.05268 1.74021 3.14645 1.64645C3.24021 1.55268 3.36739 1.5 3.5 1.5H14.5C14.6326 1.5 14.7598 1.55268 14.8536 1.64645C14.9473 1.74021 15 1.86739 15 2ZM6 10.5H12V11.5H6V10.5ZM6 13.5H10V14.5H6V13.5Z",
    fill: (0, _helpers.color)(props.fill),
    fillRule: "nonzero"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    d: "M6 6.7988C6 7.64143 6.49602 8.11355 7.32669 8.17331V8.71713H7.69721V8.16733C8.4741 8.10757 9 7.64741 9 7.00199C9 6.21912 8.31873 6.01594 7.69721 5.84263V4.39044C8.07968 4.45618 8.39641 4.73108 8.39641 5.23307H8.91633C8.91633 4.48606 8.46215 4.04382 7.69721 3.99004V3.5H7.32669V3.99004C6.57968 4.0498 6.07171 4.49203 6.07171 5.10757C6.07171 5.87849 6.70518 6.06972 7.32669 6.24303V7.76693C6.81275 7.70119 6.54382 7.37251 6.54382 6.7988H6ZM8.43227 7.04382C8.43227 7.43227 8.15737 7.70717 7.69721 7.76693V6.34462C8.10956 6.47012 8.43227 6.64343 8.43227 7.04382ZM6.63944 5.04781C6.63944 4.67131 6.96813 4.4502 7.32669 4.39044V5.73506C6.93227 5.60956 6.63944 5.44223 6.63944 5.04781Z",
    fill: (0, _helpers.color)(props.fill),
    fillRule: "nonzero"
  }));
};

exports.ReceiptIcon = ReceiptIcon;
ReceiptIcon.displayName = "ReceiptIcon";
//# sourceMappingURL=ReceiptIcon.js.map